export const ACTIONS = Object.freeze({
    SET_CLIENT: Symbol("data/client"),
    SET_MEMBERS: Symbol("data/members"),
    SET_PROJECTS: Symbol("data/projects")
});

const initialState = {
  client: null,
  members: null,
  projects: null,
};

const handler = (state = initialState, action) => {
  
  switch (action.type) {
    case ACTIONS.SET_CLIENT: {
      return {
        ...state,
        client: action.client
      };
    }
    case ACTIONS.SET_MEMBERS: {
      return {
        ...state,
        members: action.members
      };
    }
    case ACTIONS.SET_PROJECTS: {
      return {
        ...state,
        projects: action.projects
      };
    }
    default: {
      return {
        ...state
      };
    }
  } 
};

export default handler;